/**
 * Internal helpers for the Procedures services (not exported from the barrel).
 */
import { PROCEDURES_RUN_TOKEN_HEADER } from '../../models/procedures';
/** Return response.data or throw `message` when the envelope carries no data. */
export function unwrapProceduresResponse(response, message) {
    if (response.data === undefined || response.data === null)
        throw new Error(message);
    return response.data;
}
/** Request options carrying the anonymous run token as X-Run-Token (nothing when the token is empty). */
export function proceduresRunTokenOptions(runToken) {
    return runToken ? { headers: { [PROCEDURES_RUN_TOKEN_HEADER]: runToken } } : undefined;
}
//# sourceMappingURL=unwrapProceduresResponse.js.map